import { taxCreditData, taxCreditDetail, taxCreditElegibleDetail, taxCreditInProgressDetail } from "../../../testSetup/taxCredit";

export const taxCreditConstants = {
  GET_TAX_CREDIT_DATA_START: "GET_TAX_CREDIT_DATA_START",
  GET_TAX_CREDIT_DATA_SUCCESS: "GET_TAX_CREDIT_DATA_SUCCESS",
  GET_TAX_CREDIT_DATA_ERROR: "GET_TAX_CREDIT_DATA_ERROR",
  CLEAR_TAX_CREDIT_DATA: "CLEAR_TAX_CREDIT_DATA",

  GET_TAX_CREDIT_DETAIL_START: "GET_TAX_CREDIT_DETAIL_START",
  GET_TAX_CREDIT_DETAIL_SUCCESS: "GET_TAX_CREDIT_DETAIL_SUCCESS",
  GET_TAX_CREDIT_DETAIL_ERROR: "GET_TAX_CREDIT_DETAIL_ERROR",
  CLEAR_TAX_CREDIT_DETAIL: "CLEAR_TAX_CREDIT_DETAIL",

  GET_TAX_CREDIT_ELEGIBLE_DETAIL_START: "GET_TAX_CREDIT_ELEGIBLE_DETAIL_START",
  GET_TAX_CREDIT_ELEGIBLE_DETAIL_SUCCESS: "GET_TAX_CREDIT_ELEGIBLE_DETAIL_SUCCESS",
  GET_TAX_CREDIT_ELEGIBLE_DETAIL_ERROR: "GET_TAX_CREDIT_ELEGIBLE_DETAIL_ERROR",
  CLEAR_TAX_CREDIT_ELEGIBLE_DETAIL: "CLEAR_TAX_CREDIT_ELEGIBLE_DETAIL",

  GET_TAX_CREDIT_INPROGRESS_DETAIL_START: "GET_TAX_CREDIT_INPROGRESS_DETAIL_START",
  GET_TAX_CREDIT_INPROGRESS_DETAIL_SUCCESS: "GET_TAX_CREDIT_INPROGRESS_DETAIL_SUCCESS",
  GET_TAX_CREDIT_INPROGRESS_DETAIL_ERROR: "GET_TAX_CREDIT_INPROGRESS_DETAIL_ERROR",
  CLEAR_TAX_CREDIT_INPROGRESS_DETAIL: "CLEAR_TAX_CREDIT_INPROGRESS_DETAIL"
};

export function getTaxCreditData(
  auth, accountantUuid, companyUuid
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: taxCreditConstants.GET_TAX_CREDIT_DATA_START
      });

      setTimeout(function() {
        dispatch({
          type: taxCreditConstants.GET_TAX_CREDIT_DATA_SUCCESS,
          payload: { data: taxCreditData }
        });

        resolve(taxCreditData);
      }, 1500);
    });
  };
}

export function getTaxCreditDetail(taxCreditId) {
  return (dispatch, getState) => {
    // const auth = getState().auth;
    // const accountantUuid = getState().main.accountantUuid;
    // const companyUuid = getState().main.companyUuid;

    return new Promise((resolve, reject) => {
      dispatch({
        type: taxCreditConstants.GET_TAX_CREDIT_DETAIL_START
      });

      setTimeout(function() {
        dispatch({
          type: taxCreditConstants.GET_TAX_CREDIT_DETAIL_SUCCESS,
          payload: { data: taxCreditDetail }
        });

        resolve(taxCreditDetail);
      }, 1500);
    });
  };
}

export function getTaxCreditElegibleDetail(
  auth, accountantUuid, companyUuid, taxCreditId
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: taxCreditConstants.GET_TAX_CREDIT_ELEGIBLE_DETAIL_START
      });

      setTimeout(function() {
        dispatch({
          type: taxCreditConstants.GET_TAX_CREDIT_ELEGIBLE_DETAIL_SUCCESS,
          payload: { data: taxCreditElegibleDetail }
        });

        resolve(taxCreditElegibleDetail);
      }, 1500);
    });
  };
}

export function getTaxCreditInProgressDetail(
  auth, accountantUuid, companyUuid, taxCreditId
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: taxCreditConstants.GET_TAX_CREDIT_INPROGRESS_DETAIL_START
      });

      setTimeout(function() {
        dispatch({
          type: taxCreditConstants.GET_TAX_CREDIT_INPROGRESS_DETAIL_SUCCESS,
          payload: { data: taxCreditInProgressDetail }
        });

        resolve(taxCreditInProgressDetail);
      }, 1500);
    });
  };
}
